<template>
  <div class="form-container">
    <form
      v-if="!registerPageTwo"
      class="landing-form"
      @submit.prevent="submitName"
    >
      <label class="reg-label mb-1" for="userInput">{{
        $t("login.web.register_username_label")
      }}</label>
      <input
        id="userInput"
        v-model="userInput"
        name="userInput"
        class="form-control"
        :class="{ error: !usernameLength && displayNameFeedback }"
        required
        autofocus="true"
        autocomplete="username"
      />
      <p
        v-if="!displayNameFeedback || usernameLength"
        class="w-100 mb-0 text-center info-text"
      >
        {{ $t("login.web.register_username_info") }}
      </p>
      <p
        v-else-if="!usernameLength && displayNameFeedback"
        class="w-100 mb-0 text-center info-text text-danger"
      >
        {{ $t("login.web.register.invalid_feedback.username") }}
      </p>
      <p class="primary-accent medium mb-0 mt-3 text-center toggle-text">
        <i18next
          :translation="$t('login.web.register.login_message')"
          @click="$emit('toggle')"
        >
          <template #link>
            <a href="#" @click.prevent="$emit('toggle')">{{
              $t("login.web.register.here_link")
            }}</a></template
          >
        </i18next>
      </p>

      <div
        class="w-100 d-inline-flex align-items-center justify-content-center mt-3"
      >
        <button
          type="submit"
          name="username-submit"
          class="ok-button-green w-50 ms-1"
          :disabled="disabledButton === 'username-submit'"
        >
          {{ $t("login.web.register_next") }}
        </button>
      </div>
    </form>
    <form
      v-else
      novalidate="true"
      class="landing-form"
      :class="{ 'no-checkbox': !$whitelabel.featuresEnabled.checkbox }"
      @submit.prevent="submitRegister"
    >
      <div class="form-group mb-3 mt-3">
        <input
          v-model="email"
          type="email"
          name="register-email"
          autofocus="true"
          class="form-control"
          :class="{
            error: !validEmail && displayOtherFeedback,
          }"
          required
          :placeholder="$t('login.web.email_placeholder')"
          autocomplete="register-email"
        />
        <p
          v-if="!validEmail && displayOtherFeedback"
          class="w-100 to-center-abs small m-0 text-center text-danger"
        >
          {{ $t("login.web.register.invalid_feedback.email") }}
        </p>
      </div>
      <div class="form-group mb-3">
        <input
          v-model="password"
          name="register-password"
          type="password"
          class="form-control"
          :class="{
            error: !minLength && displayOtherFeedback,
          }"
          required
          :placeholder="$t('login.web.register.choose_password')"
          autocomplete="register-password"
        />
        <p
          v-if="!minLength && displayOtherFeedback"
          class="w-100 to-center-abs small m-0 text-center text-danger"
        >
          {{ $t("profile.change_password.invalid_feedback.length", { 0: 6 }) }}
        </p>
      </div>
      <div class="form-group">
        <input
          v-model="passwordRepeat"
          name="register-password-repeat"
          type="password"
          class="form-control"
          :class="{ error: !passwordMatch && displayOtherFeedback }"
          required
          :placeholder="$t('login.web.password_repeat_placeholder')"
          autocomplete="register-password"
        />
        <p
          v-if="!passwordMatch && displayOtherFeedback"
          class="w-100 to-center-abs small m-0 text-center text-danger"
        >
          {{ $t("profile.change_password.invalid_feedback.match") }}
        </p>
      </div>

      <div class="w-100 d-flex align-items-center justify-content-center">
        <div v-if="$whitelabel.featuresEnabled.checkbox" class="w-50">
          <div class="form-group mb-0">
            <label
              class="modern-check-label mb-0"
              for="newsletter-check"
              tabindex="0"
              role="checkbox"
              @keydown.space.prevent="newsletterCheck = !newsletterCheck"
            >
              <span class="pseudo-label d-block">
                <i18next :translation="$t('login.web.register.newsletter_new')">
                  <template #0>
                    <span class="bold" place="0">
                      {{ newsletterGold }}
                    </span></template
                  >
                </i18next>
                *
              </span>
              <input
                id="newsletter-check"
                v-model="newsletterCheck"
                type="checkbox"
                tabindex="-1"
                checked /><span class="blue-checkmark"></span
            ></label>
          </div>
          <div class="form-group mb-0">
            <label
              class="modern-check-label mb-0"
              name="checkagb"
              for="tac-check"
              tabindex="0"
              role="checkbox"
              @keydown.space.prevent="agbCheck = !agbCheck"
            >
              <div
                class="pseudo-label"
                :class="{ error: !agbCheck && displayOtherFeedback }"
                v-html="localeTac"
              ></div>
              <input
                id="tac-check"
                v-model="agbCheck"
                type="checkbox"
                tabindex="-1" /><span class="blue-checkmark"></span
            ></label>
          </div>
          <div class="form-group mb-0">
            <label
              class="modern-check-label mb-0"
              name="checkage"
              for="age-check"
              tabindex="0"
              role="checkbox"
              @keydown.space.prevent="ageCheck = !ageCheck"
            >
              <div
                class="pseudo-label"
                :class="{ error: !ageCheck && displayOtherFeedback }"
              >
                {{ $t("register.over_18") }}
              </div>
              <input
                id="age-check"
                v-model="ageCheck"
                type="checkbox"
                tabindex="-1" /><span class="blue-checkmark"></span
            ></label>
          </div>
        </div>

        <button
          type="submit"
          name="register-submit"
          class="ok-button-green play-now-button"
          :class="{
            'w-50': $whitelabel.featuresEnabled.checkbox,
            'w-75 mx-auto mt-3': !$whitelabel.featuresEnabled.checkbox,
          }"
        >
          {{ $t("login.web.register.play_now_button") }}
        </button>
      </div>
      <div class="w-100 text-center">
        <a
          href="#"
          class="primary-accent bold mx-auto text-normal back-link"
          @click.prevent="handleBack"
          >{{ $t("support.faq.back") }}</a
        >
      </div>

      <!-- <vue-friendly-captcha
      :sitekey="friendlySitekey"
      class="mx-auto"
      :dark="true"
      :language="$store.state.locale"
      @started="disabledButton = 'register-submit'"
      @done="handleCaptchaDone"
    /> -->
    </form>
    <p class="primary-accent social-title mb-2">
      {{ $t("login.3rd_party_signup") }}
    </p>

    <div class="social-grid">
      <button
        v-if="$whitelabel.featuresEnabled.apple"
        type="button"
        class="social-btn"
      >
        <img src="@/assets/img/social/apple.png" alt="Apple" />
      </button>
      <div
        v-if="
          $store.getters.facebookEnabled && $whitelabel.featuresEnabled.facebook
        "
        class="social-btn fb-wrapper"
      >
        <v-facebook-login
          :app-id="facebookAppId"
          type="button"
          version="v18.0"
          class="vfb-as-icon"
          :class="{ 'd-none': !displayFbButton }"
          :use-default-style="false"
          @login="handleFbLogin"
          @logout="$emit('facebookLogout')"
          @sdk-init="displayFbButton = true"
        >
          <template #login>
            <img src="@/assets/img/social/facebook.png" alt="Facebook" />
          </template>
        </v-facebook-login>
      </div>

      <button
        v-if="$whitelabel.featuresEnabled.google"
        type="button"
        class="social-btn"
        @click="handleGoogleLogin"
      >
        <img src="@/assets/img/social/google.png" alt="Google" />
      </button>

      <button
        v-if="$whitelabel.featuresEnabled.paypal_login"
        class="social-btn"
        @click="startPaypalLogin"
      >
        <img src="@/assets/img/social/paypal.png" alt="Log in with PayPal" />
      </button>
    </div>
    <div class="text-white footnote">
      <div
        class="pseudo-label"
        :class="{ error: !agbCheck && displayOtherFeedback }"
        v-html="localeTac"
      ></div>
    </div>
  </div>
</template>

<script>
import { VFBLogin as VFacebookLogin } from "vue-facebook-login-component";
import { checkNameForBlacklist } from "@/API/auth.js";
export default {
  name: "RegisterFrom",
  components: { VFacebookLogin },
  props: {
    friendReferrer: {
      type: String,
      default: "",
    },
    registerPageTwo: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      userInput: "",
      email: "",
      password: "",
      passwordRepeat: "",
      newsletterCheck: false,
      agbCheck: false,
      ageCheck: false,
      displayNameFeedback: false,
      displayEmailFeedback: false,
      displayOtherFeedback: false,
      facebookAppId: process.env.VUE_APP_FACEBOOK_APP_ID,
      // friendlySitekey: process.env.VUE_APP_FRIENDLY_CAPTCHA_SITEKEY,
      disabledButton: "",
      displayFbButton: false,
      // captchaSolution: "",
    };
  },
  computed: {
    lpBonusName() {
      return this.$store.state.auth.lpBonusName;
    },
    usernameLength() {
      return this.userInput.length >= 3 && this.userInput.length <= 40;
    },
    minLength() {
      return this.password.length >= 6;
    },
    passwordMatch() {
      return this.password === this.passwordRepeat;
    },
    validEmail() {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    },

    localeTac() {
      if (this.$store.state.locale === "en") {
        return "In the game, our <a href='/tac?locale=en'>TAC</a> and <a href='/privacy?locale=en'>Privacy Policy</a> are valid.";
      } else {
        return "Im Spiel gelten unsere  <a href='/tac?locale=de'>AGB</a> und unsere <a href='/privacy?locale=de'>Datenschutzerklärung</a>.";
      }
    },
    everythingSet() {
      const baseValid = this.validEmail && this.minLength && this.passwordMatch;

      if (this.$whitelabel.featuresEnabled.checkbox) {
        return baseValid && this.agbCheck && this.ageCheck;
      }

      return baseValid;
    },

    newsletterGold() {
      let settings = this.$store.state.generalConfig.settings;
      if (settings["user.newsletter.register.gold"]) {
        return this.formatNumber(
          settings["user.newsletter.register.gold"],
          true
        );
      }

      return this.formatNumber(10000000, true);
    },
  },
  watch: {
    error() {
      this.disabledButton = "";
    },
  },
  mounted() {
    this.$store.commit("setIsPageLoading", false);
    this.$root.$on("ok-name-error", () => {
      this.userInput = "";
    });
  },
  methods: {
    // handleCaptchaDone(e) {
    //   this.captchaSolution = e;
    //   this.disabledButton = "";
    // },
    // handleCaptchaError(e) {
    //   this.captchaSolution = "";
    //   console.log("Friendly Captcha Error", e);
    // },
    async handleGoogleLogin() {
      try {
        const provider = new firebase.auth.GoogleAuthProvider();
        provider.setCustomParameters({ prompt: "select_account" });
        const result = await firebase.auth().signInWithPopup(provider);
        const accessToken = await result.credential.accessToken;
        this.$emit("googleConnected", accessToken);
      } catch (e) {
        console.log("Google sign-in failed:", e);
        this.$emit("error");
      }
    },
    startPaypalLogin() {
      const base =
        process.env.NODE_ENV === "production"
          ? "https://www.paypal.com/signin/authorize"
          : "https://www.sandbox.paypal.com/signin/authorize";

      const clientId = process.env.VUE_APP_PAYPAL_CLIENT_ID;

      const redirectUri = `${window.location.origin}/login`;
      const state = encodeURIComponent(window.location.href);

      const authUrl = new URL(base);
      authUrl.searchParams.set("flowEntry", "static");
      authUrl.searchParams.set("client_id", clientId);
      authUrl.searchParams.set("response_type", "code");
      authUrl.searchParams.set("scope", "openid profile email");
      authUrl.searchParams.set("redirect_uri", redirectUri);
      authUrl.searchParams.set("state", state);

      window.location.assign(authUrl.toString());
    },
    handleFbLogin(e) {
      if (e.status === "connected") {
        this.$emit("facebookConnected", e.authResponse.accessToken);
      } else {
        console.log(e);
      }
    },
    submitRegister(e) {
      this.disabledButton = "register-submit";
      if (this.everythingSet) {
        let userData = {
          name: this.userInput,
          email: this.email,
          password: this.password,
          newsletter: this.newsletterCheck,
          startapp: this.friendReferrer,
          // "frc-captcha-solution": this.captchaSolution,
        };

        //use code from landing page and set bonus
        if (this.lpBonusName) {
          userData.source = this.lpBonusName;
          userData.medium = "exit_intend";
        }

        this.$emit("submitRegister", userData);
      } else {
        this.displayOtherFeedback = true;
        this.disabledButton = "";
      }
    },
    submitName() {
      this.disabledButton = "username-submit";
      if (this.usernameLength) {
        const locale = this.$store.getters.getLocale;
        const localeQuery = locale + "_" + locale.toUpperCase();
        checkNameForBlacklist(this.userInput, localeQuery)
          .then((res) => {
            this.googleTagLogNormalEvent("Next");
            this.$emit("page2");
          })
          .catch((e) => {
            console.log(e);
            this.userInput = "";
            this.disabledButton = "";
            if (e.data.details.name[0]) {
              this.$store.commit("popups/setAlertBannerContent", {
                alertText: e.data.details.name[0],
                alertHeading: this.$t("alerts.title.error"),
                variant: "danger",
                type: "danger",
              });
            } else {
              this.$store.commit("popups/setAlertBannerContent", {
                alertText: this.$t("user.error.name_blacklisted"),
                alertHeading: this.$t("alerts.title.error"),
                variant: "danger",
                type: "danger",
              });
            }
          });
      } else {
        this.displayNameFeedback = true;
        this.disabledButton = "";
      }
    },
    handleFbRegister(e) {
      if (e.status === "connected") {
        this.firebaseSetUser("FB");
        this.googleTagLogAdvancedEvent({
          event: "Registrierung",
          label: "Facebook",
        });
        this.$emit("facebookConnected", e.authResponse.accessToken);
      } else {
        console.log(e);
      }
    },
    handleBack() {
      this.disabledButton = "";
      this.$emit("back");
    },
  },
};
</script>
<style lang="scss">
.form-container {
  margin-top: 3.5rem;
}
.landing-form {
  .reg-label {
    font-size: 16px;
  }
  .back-link {
    display: inline-block;
    margin-top: 1.5rem;
  }
}
.landing-form.no-checkbox {
  margin-top: -3rem;
}
.social-title {
  font-weight: 600;
  text-align: left;
  margin-bottom: 1rem;
  margin-top: 2rem;
}

.social-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  max-width: 100%;
  margin: 0 auto;
}

.social-grid .v-facebook-login {
  background: transparent !important;
  padding: 0 !important;
  border: 0 !important;
  width: 50px !important;
  height: 50px !important;
  min-width: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 0 !important;
}

:deep(.v-facebook-login iframe) {
  display: none !important;
}

.social-grid .v-facebook-login > svg.token,
.social-grid .v-facebook-login > svg {
  display: none !important;
}

.fb-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  .v-facebook-login {
    all: unset;
    width: 100%;
    height: 100%;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    button {
      all: unset !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100%;
      height: 100%;
      margin: 0 !important;
      padding: 0 !important;
      line-height: normal !important;
    }

    img {
      width: 28px !important;
      height: 28px !important;
      display: block !important;
    }
  }
}

.social-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  width: 100px;
  height: 40px;
  padding: 0;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.6);
    background: rgba(255, 255, 255, 0.05);
  }

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
    filter: drop-shadow(0 0 4px rgba(233, 76, 255, 0.4));
  }
}
.footnote {
  text-align: center;
  margin-top: 1.5rem;
  font-size: 9px;
  a {
    color: #007bff !important;
    &:hover {
      text-decoration: underline !important;
    }
  }
}
</style>
